import {
    getApiErrorMessage,
    getFormMode,
    getResponseData
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { getCodUsuarioRegistrou } from 'lib/functions';
import { FormActions, FormStatusSwitch } from 'views/Components';

const ROTA_LISTA = '/crm/grupomsgwhatsappfornecedor';

class GrupoMsgWhatsAppFornecedorForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        grupomensagem: {},
        isNewRecord: false,
        isView: false,
        openAlert: false,
        messageAlert: '',
        errors: {}
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({ isNewRecord: true });

                return;
            }

            if (id !== '' && !isNaN(Number(id))) {
                await this.loadGrupoMensagem(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar o grupo de mensagens:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar o grupo de mensagens!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Carrega o grupo de mensagens */
    loadGrupoMensagem = async (id, isView) => {
        const response = await api.get(`/whatsapp/grupomensagemfornecedor/${id}`);
        const registro = getResponseData(response)[0];

        if (!registro) {
            this.handleOpenAlert('Grupo de mensagens não encontrado!');

            return;
        }

        this.safeSetState({
            grupomensagem: registro,
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        let adjustedValue = value;

        if (type === 'checkbox') {
            if (name === 'inativo') {
                adjustedValue = checked ? ANAO : ASIM;
            }
        } else {
            adjustedValue = value.toUpperCase();
        }

        this.setState(prevState => ({
            grupomensagem: {
                ...prevState.grupomensagem,
                [name]: adjustedValue
            },
            errors: {
                ...prevState.errors,
                [name]: ''
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { grupomensagem, isNewRecord } = this.state;
        const { history } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            return;
        }

        try {
            if (isNewRecord) {
                await api.post('/whatsapp/grupomensagemfornecedor', {
                    ...grupomensagem,
                    codusuarioregistrou: getCodUsuarioRegistrou()
                });
            } else {
                await api.put(
                    `/whatsapp/grupomensagemfornecedor/${grupomensagem.idgrupomsgwhats}`,
                    grupomensagem
                );
            }

            history.push(ROTA_LISTA);
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push(ROTA_LISTA);
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { nome } = this.state.grupomensagem;

        const errors = {};

        if (!nome || String(nome).trim() === '') {
            errors.nome = 'Nome do grupo obrigatório';
        }

        return errors;
    };

    render() {
        const {
            errors,
            grupomensagem,
            isView,
            messageAlert,
            openAlert
        } = this.state;

        const { idgrupomsgwhats, inativo, nome } = grupomensagem;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Grupo de mensagens {idgrupomsgwhats}
                        </Typography>

                        <FormStatusSwitch
                            checked={inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <TextField
                        label="Nome do grupo de mensagens"
                        name="nome"
                        value={nome || ''}
                        variant="outlined"
                        onChange={this.onChange}
                        helperText={errors.nome || ' '}
                        error={!!errors.nome}
                        disabled={isView}
                        inputProps={{ maxLength: 100 }}
                        fullWidth
                    />

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

GrupoMsgWhatsAppFornecedorForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object
};

export default GrupoMsgWhatsAppFornecedorForm;